import React from 'react';
import { Link, Image, Video } from 'lucide-react';
import { PostType } from '../../types';

interface PostTypeToggleProps {
  value: PostType | '';
  onChange: (event: React.MouseEvent | null, newValue: PostType | '') => void;
  disabled?: boolean;
}

export const PostTypeToggle: React.FC<PostTypeToggleProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleChange = (event: React.MouseEvent | null, newValue: PostType | '') => {
    // If clicking the same selected value, clear it
    if (newValue === value) {
      onChange(event, '');
    } else {
      onChange(event, newValue);
    }
  };

  return (
    <div className="flex justify-center w-full">
      <div className="flex gap-2 w-full">
        <button
          type="button"
          onClick={() => handleChange(null, value === 'link' ? '' : 'link')}
          disabled={disabled}
          className={`flex-1 px-4 py-3 min-w-[100px] rounded flex items-center justify-center gap-2 font-medium transition-colors ${
            value === 'link'
              ? 'bg-primary text-onfill border border-primary hover:bg-primary-medium'
              : 'bg-form-dark text-cmp-ink border border-white hover:bg-cmp-bronze-soft'
          } ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
          aria-label="link"
        >
          <Link className="w-9" />
          <span>Link</span>
        </button>
        <button
          type="button"
          onClick={() => handleChange(null, value === 'photo' ? '' : 'photo')}
          disabled={disabled}
          className={`flex-1 px-4 py-3 min-w-[100px] rounded flex items-center justify-center gap-2 font-medium transition-colors ${
            value === 'photo'
              ? 'bg-primary text-onfill border border-primary hover:bg-primary-medium'
              : 'bg-form-dark text-cmp-ink border border-white hover:bg-cmp-bronze-soft'
          } ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
          aria-label="photo"
        >
          <Image className="w-9" />
          <span>Photo</span>
        </button>
        <button
          type="button"
          onClick={() => handleChange(null, value === 'video' ? '' : 'video')}
          disabled={disabled}
          className={`flex-1 px-4 py-3 min-w-[100px] rounded flex items-center justify-center gap-2 font-medium transition-colors ${
            value === 'video'
              ? 'bg-primary text-onfill border border-primary hover:bg-primary-medium'
              : 'bg-form-dark text-cmp-ink border border-white hover:bg-cmp-bronze-soft'
          } ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
          aria-label="video"
        >
          <Video className="w-9" />
          <span>Video</span>
        </button>
        <button
          type="button"
          onClick={() => handleChange(null, value === 'reel' ? '' : 'reel')}
          disabled={disabled}
          className={`flex-1 px-4 py-3 min-w-[100px] rounded flex items-center justify-center gap-2 font-medium transition-colors ${
            value === 'reel'
              ? 'bg-primary text-onfill border border-primary hover:bg-primary-medium'
              : 'bg-form-dark text-cmp-ink border border-white hover:bg-cmp-bronze-soft'
          } ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
          aria-label="reel"
        >
          <Video className="w-9" />
          <span>Reel</span>
        </button>
      </div>
    </div>
  );
};
